import { $,_,Backbone,Radio } from '../../vendor'

import { Biscuit,IcsBuilder } from '../utils'
import InboomaBaseController from './InboomaBaseController'

import MyInboomaOverviewView from '../views/myInbooma/index/MyInboomaIndexView'

import { app404Tpl } from '../views/AppAnnouncements'

export default InboomaBaseController.extend({
  
  _template: `
    <div id="inb-c-main" class="columns" style="margin-left:0;width:100%;">

        <div id="inb-c-main-access-bar" class="clearfix">
        </div>

        <div class="off-canvas-wrapper column">
            <div id="inb-c-main-my-inbooma"></div>
        </div>

    </div>`,

  _shouldRenderLayout () {
      return (!$('#inb-c-main-my-inbooma').length)
  },

  _accessBarMap () {
      return {
        pageTitle: this.t('my_inbooma',null,'capital'),
        linksMap: {
          overview: {
            url: '/my-inbooma',
            icon: 'fi fi-list'
          }
        }
      }
  },

  notFoundError () {
      this.app.trigger('show:announcement', app404Tpl)
  },

  createClientIcs () {
    
      new IcsBuilder(
        {
          'client_id' : Number(Biscuit.get('user.client_id')),
        },
        'inbooma_client_' + Biscuit.get('user.client_id')
      );
  },

  overview (render) {

      if (render === null) {
        render = true;
      }

      if (render) {
        const myInboomaOverviewView = new MyInboomaOverviewView({
          el: '#inb-c-main-my-inbooma'
        })
      }

  }

});